/* Móveo — cookie consent (Shopify Customer Privacy API) + accessibility toolbar */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (_) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (_) {} }
  };
  const readJSON = (k) => { try { return JSON.parse(store.get(k) || '{}') || {}; } catch (_) { return {}; } };

  /* ---------------- Cookie consent ---------------- */
  const banner = $('[data-cookie-banner]');
  const MODE = (banner && banner.dataset.mode) || 'optout';
  const LOCAL_KEY = 'mv-consent';
  let privacy = null;

  const recorded = () => {
    if (privacy && typeof privacy.currentVisitorConsent === 'function') {
      const c = privacy.currentVisitorConsent() || {};
      if (c.marketing === 'yes' || c.marketing === 'no' || c.analytics === 'yes' || c.analytics === 'no') return true;
    }
    return !!store.get(LOCAL_KEY);
  };

  const setPrefs = (on) => {
    const p = $('[data-cookie-prefs]', banner);
    const s = $('[data-cookie-save]', banner);
    if (p) p.hidden = !on;
    if (s) s.hidden = !on;
  };
  const showBanner = (withPrefs) => {
    if (!banner) return;
    banner.hidden = false;
    setPrefs(withPrefs);
    const saved = readJSON(LOCAL_KEY);
    const fallback = MODE === 'optout';
    const a = $('[data-cookie-analytics]', banner);
    const m = $('[data-cookie-marketing]', banner);
    if (a) a.checked = 'analytics' in saved ? !!saved.analytics : fallback;
    if (m) m.checked = 'marketing' in saved ? !!saved.marketing : fallback;
    const first = $('button', banner);
    if (first) first.focus({ preventScroll: true });
  };
  const hideBanner = () => { if (banner) banner.hidden = true; };

  const applyConsent = (analytics, marketing) => {
    store.set(LOCAL_KEY, JSON.stringify({ analytics, marketing, preferences: true, mode: MODE, at: new Date().toISOString() }));
    if (privacy && typeof privacy.setTrackingConsent === 'function') {
      privacy.setTrackingConsent({ analytics, marketing, preferences: true, sale_of_data: marketing }, () => {});
    }
    hideBanner();
    document.dispatchEvent(new CustomEvent('moveo:consent', { detail: { analytics, marketing } }));
  };

  const initBanner = () => {
    if (!banner) return;
    banner.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cookie-action]');
      if (!btn) return;
      const act = btn.dataset.cookieAction;
      if (act === 'accept') applyConsent(true, true);
      else if (act === 'reject') applyConsent(false, false);
      else if (act === 'prefs') { const p = $('[data-cookie-prefs]', banner); setPrefs(p ? p.hidden : true); }
      else if (act === 'save') {
        const a = $('[data-cookie-analytics]', banner);
        const m = $('[data-cookie-marketing]', banner);
        applyConsent(!!(a && a.checked), !!(m && m.checked));
      }
    });
    $$('[data-cookie-open]').forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); showBanner(true); }));
    if (!recorded()) showBanner(false);
  };

  const loadPrivacy = () => new Promise((resolve) => {
    if (window.Shopify && window.Shopify.customerPrivacy) { resolve(window.Shopify.customerPrivacy); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
        resolve(err ? null : (window.Shopify.customerPrivacy || null));
      });
    } else resolve(null);
  });

  loadPrivacy().then((p) => { privacy = p; initBanner(); });

  /* ---------------- Accessibility toolbar ---------------- */
  const A11Y_KEY = 'mv-a11y';
  const root = document.documentElement;
  const panel = $('[data-a11y-panel]');
  const toggle = $('[data-a11y-toggle]');
  const defaults = () => ({ text: 0, contrast: false, links: false, font: false, still: false });
  let state = Object.assign(defaults(), readJSON(A11Y_KEY));
  if (!store.get(A11Y_KEY) && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) state.still = true;

  const pauseVideos = () => $$('video').forEach((v) => { try { v.pause(); } catch (_) {} });
  document.addEventListener('play', (e) => {
    if (state.still && e.target && e.target.tagName === 'VIDEO' && e.target.muted) e.target.pause();
  }, true);

  const render = () => {
    root.classList.remove('a11y-text-1', 'a11y-text-2', 'a11y-text-3');
    if (state.text > 0) root.classList.add(`a11y-text-${state.text}`);
    root.classList.toggle('a11y-contrast', !!state.contrast);
    root.classList.toggle('a11y-links', !!state.links);
    root.classList.toggle('a11y-font', !!state.font);
    root.classList.toggle('a11y-still', !!state.still);
    if (state.still) pauseVideos();
    if (panel) {
      $$('[data-a11y]', panel).forEach((b) => {
        const k = b.dataset.a11y;
        if (k in state && typeof state[k] === 'boolean') b.setAttribute('aria-pressed', String(state[k]));
      });
      const lvl = $('[data-a11y-level]', panel);
      if (lvl) lvl.textContent = state.text === 0 ? 'רגיל' : `+${state.text}`;
    }
    store.set(A11Y_KEY, JSON.stringify(state));
  };

  if (panel && toggle) {
    const open = () => { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); const f = $('button', panel); if (f) f.focus(); };
    const close = () => { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); };
    toggle.addEventListener('click', () => (panel.hidden ? open() : close()));
    panel.addEventListener('click', (e) => {
      const b = e.target.closest('[data-a11y]');
      if (!b) return;
      const k = b.dataset.a11y;
      if (k === 'close') { close(); return; }
      if (k === 'bigger') state.text = Math.min(3, state.text + 1);
      else if (k === 'smaller') state.text = Math.max(0, state.text - 1);
      else if (k === 'reset') state = defaults();
      else if (k in state) state[k] = !state[k];
      if ((k === 'still' || k === 'reset') && !state.still) {
        $$('video[autoplay]').forEach((v) => { const p = v.play(); if (p && p.catch) p.catch(() => {}); });
      }
      render();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) close(); });
  }
  render();
})();
